import EventTypes from "./EventTypes";
import { DEFAULT_FILL_COLOR } from "./constants";

const getBaseUrl = (p) => {
    let path = p.getURLPath();
    return `/${path[0]}/${path[1]}`;
}

const getPlanPath = (p) => {
    let path = p.getURLPath();
    return `/${path[0]}/${path[1]}/${path[2]}`;
}

const getUsername = (p) => {
    return p.getURLPath()[0];
}

const getPlanSlug = (p) => {
    return p.getURLPath()[2] == 'mobile' ? p.getURLPath()[3] : p.getURLPath()[2];
}

const isNewPlan = (p) => {
    return p.getURLPath()[1] == 'new';
}

const windowResized = (provider) => {
    provider.emit(EventTypes.RESIZE_WINDOW);
    // Need to use document for chrome because windowWidth/Height has a bug on chrome. https://github.com/processing/p5.js/issues/5130
    provider.p.resizeCanvas(document.documentElement.clientWidth, document.documentElement.clientHeight - (provider.touch ? 0 : 7));

    provider.zoomMenu.position();
    provider.speciesInfo.reposition();
}

const getTimestamp = () => {
    return Math.floor(Date.now() / 1000);
}

const focusInput = (input) => {
    if (input && input.visible) {
        // make sure the hot key is not entered in input
        setTimeout(
            () => input.focus(),
            10
        );
    }
}

const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const normalizeAngle = (angle) => {
    return angle % (Math.PI * 2);
}

const addSvg = (element, svgName, isInnerElement = false) => {
    let svg = SVG()
        .addTo(isInnerElement ? element : element.elt);
    svg.use(svgName, '/icons/__remixicon.sprite.svg?v=491');
    return svg;
}

const createRowButton = (p, parent, tooltip, func, svgId) => {
    let btn = p.createDiv()
        .parent(parent)
        .class('btn-icon')
        .attribute('data-tooltip', tooltip)
        .mouseClicked(func);
    addSvg(btn, svgId);
    return btn;
}

// Draws a banner when the draw loop throws. A broken canvas then prompts a
// reload instead of freezing silently and looking like an unresponsive Save.
const displayDrawError = (p) => {
    try {
        p.push();
        p.resetMatrix();
        p.noStroke();
        p.fill(185, 28, 28);
        p.rect(0, 0, p.width, 44);
        p.fill(255);
        p.textSize(14);
        p.textAlign(p.CENTER, p.CENTER);
        p.text('Something went wrong drawing your plan. Please reload the page.', p.width / 2, 22);
        p.pop();
    } catch (_) {
        // The canvas itself is unusable; nothing more we can draw.
    }
}

// Builds the default ellipse element for a species (used by SpeciesRow's
// "Plant this" and the ?plant= preload on /plans/new)
const makePlantElement = (provider, species) => {
    const size = species.Width && species.Width != 'not specified' ? parseFloat(species.Width) : 1
    const layer = Array.isArray(species.Layer) ? species.Layer[0] : species.Layer;
    return provider.elementFactory.makeEllipse({
        type: 'ellipse',
        data: {
            x: 0,
            y: 0,
            width: size * 100,
            height: size * 100,
            labels: [
                {
                    type: 'species',
                    id: species.id,
                    keys: species.type !== 'Variety'
                        ? ['name', 'scientific_name']
                        : ['parent_name', 'name', 'scientific_name']
                }
            ],
            labelX: 0,
            labelY: 0,
            fillColor: DEFAULT_FILL_COLOR,
            strokeColor: null,
            strokeWidth: null,
            layer: layer,
            canopyStyle: 'lobed',
            canopySeed: Math.floor(Math.random() * 100000),
        },
        speciesIds: [species.id],
    });
}

export { getBaseUrl, getUsername, getPlanSlug, isNewPlan, windowResized, getTimestamp, focusInput, capitalize, getPlanPath, normalizeAngle, addSvg, createRowButton, makePlantElement, displayDrawError };
